import Device from '../Device';
import vp from '../../../services/api/vp';

const questions = [
  {
    type: 'text',
    label: 'step3EnphaseLabel',
    advanceOnEnter: true,
    advanceOnValue: false,
    name: 'serialNumber',
    model: 'serialNumber',
    validation: 'required',
  },
];

const addDevice = async (values, context) => {
  const deviceData = {
    ...values,
    mfg: 'enphase',
    deviceType: 'battery',
    ...Device.commonAddDeviceParameters(context),
  };

  return vp.addDevice(deviceData);
};

const EnphaseDirectInstall = new Device('enphaseDirectInstall', { mfg: 'enphase', questions, addDevice });

export default EnphaseDirectInstall;
